import StickyJs from 'sticky-js'

export default class Sticky {
    constructor() {
        this.selector = '.front-page-section-header__container'
        this.sticky = new StickyJs(this.selector);
    }
}